import React, {useState} from 'react';
import {logoTextWhite} from '../../assets/images';

interface Props {
  src?: string | null;
  fallbackSrc?: string;
  fallbackClassName?: string;
  className?: string;
  alt?: string;
}

const ImageWithFallback = React.memo(
  ({
    src,
    fallbackSrc = logoTextWhite,
    fallbackClassName = 'PlaceholderLogo',
    className,
    alt = '',
  }: Props) => {
    const [hasError, setHasError] = useState(false);

    if (!src || hasError) {
      return <img src={fallbackSrc} className={fallbackClassName} alt={alt} />;
    }

    return (
      <img
        src={src}
        className={className}
        alt={alt}
        onError={() => setHasError(true)}
      />
    );
  },
);

export default ImageWithFallback;
